import useInventorySummaryStore from '../store/inventorySummaryStore';
import { SummaryWidgetKey } from '../definitions/inventorySummary';

interface WidgetCount {
  count: number | undefined;
  loading: boolean;
  error: boolean;
}

const useWidgetCount = (key: SummaryWidgetKey): WidgetCount => {
  const { counts, loadingKeys, errorKeys } = useInventorySummaryStore();

  return {
    count: counts[key],
    loading: !!loadingKeys[key],
    error: !!errorKeys[key],
  };
};

export default useWidgetCount;
